import React, { useEffect, useState } from 'react'
import { Col, Container, Row, Form } from 'react-bootstrap'
import { Link, useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import axios from "axios";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { login, userStore } from "../../redux/reduxStore.js";
import Testimonials from '../Testimonials.jsx';
import Loader from '../Loader.jsx';

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [verifyMsg, setVerifyMsg] = useState(null);
  const [loader, setLoader] = useState(false);
  const { token } = useParams();
  const handleEmailVerify = () => {
    if (!token) {
      return;
    }
    axios({
      method: "POST",
      url: `${process.env.REACT_APP_BASE_URL}/user/email-verify`,
      headers: {
        "Content-Type": "application/json"
      },
      data: JSON.stringify({
        token: token
      }),
    }).then(res => {
      setVerifyMsg(res.data.message);
    }).catch(err => {
      setVerifyMsg(err?.response?.data?.message || err.message || "Server error");
    });
  }
  const { register, handleSubmit, formState: { errors }, reset, } = useForm({ defaultValues: { email: "", password: "" } });
  const handleLogin = (data) => {
    setLoader(true);
    axios({
      method: "post",
      url: `${process.env.REACT_APP_BASE_URL}/user/login`,
      headers: {
        "Content-Type": "application/json"
      },
      data: JSON.stringify({
        email: data.email,
        password: data.password
      }),
    }).then((res) => {
      setLoader(false);
      if (!res.data.user) {
        return toast("User is not found", {
          theme: "light",
          type: "error",
          position: "top-right"
        });
      }
      toast("Login successfully", {
        theme: "light",
        type: "success",
        position: "top-right"
      });
      userStore.dispatch(login({
        user: res.data.user,
        token: res.data.token,
      }));
      reset({ email: "", password: "" });
      return navigate('/');
    }).catch((err) => {
      setLoader(false);
      if (err?.response?.data?.errors) {
        return toast(err.response.data.errors[0].msg, {
          theme: "light",
          type: "error",
          position: 'top-right'
        });
      } else {
        return toast(err?.response?.data?.message || err?.message || "Login unsuccessful. The server is not responding.", {
          theme: "light",
          type: "error",
          position: 'top-right'
        });
      }
    });
  }

  useEffect(() => {
    handleEmailVerify();
  }, []);

  return (
    <>
      <section className='form-section login'>
        <Container>
          <Row className="justify-content-center">
            <Col xxl={5} lg={6} md={8} sm={10}>
              <div className="boxwrap">
                <h2 className='text-gradient'>Login</h2>
                <p className="mb-3">{verifyMsg ? verifyMsg : 'Sign in to your account to continue.'}</p>
                <Form className="row" onSubmit={handleSubmit(handleLogin)}>
                  <Form.Group as={Col} md="12" className="mb-3" controlId="login-Email">
                    <Form.Label>Email address <span>*</span></Form.Label>
                    <Form.Control
                      type="email" placeholder='Enter your email address'
                      {...register('email', {
                        required: { message: "E-Mail is require", value: true },
                        pattern: { message: 'E-Mail is not valid', value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/g }
                      }
                      )} />
                    {errors.email ? <p className='errMsg'>{errors.email.message}</p> : null}
                  </Form.Group>

                  <Form.Group as={Col} md="12" className="mb-3" controlId="login-Password">
                    <div className="d-flex align-items-center justify-content-between">
                      <Form.Label>Password <span>*</span></Form.Label>
                      <Link to={'/forgotpassword'}>Lost password ?</Link>
                    </div>

                    <Form.Control
                      type="password" placeholder='Enter your password'
                      {...register("password", {
                        required: { message: "Password is require", value: true },
                        pattern: { message: "Password is too weak", value: /^(?=.*\d)(?=.*[a-zA-Z]).{6,}$/g }
                      })} />
                    {errors.password ? <p className='errMsg'>{errors.password.message}</p> : null}
                  </Form.Group>
                  <div className="mb-4">
                    <button type="submit" className="button blue w-100 py-3">Submit</button>
                  </div>
                  <Col md={12} className="mt-3">
                    <p className='mb-0'>Not Registered ? <Link to={'/register'}>Create account</Link></p>
                  </Col>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <Testimonials />
      <Loader show={loader}/>
    </>
  )
}

export default Login